import {createSlice} from "@reduxjs/toolkit";

const appLoaderSlice = createSlice({
    name: "appLoader",
    initialState: {
        isVisible: false,
    },
    reducers:{
        setAppLoader: (state, action) => ({...action.payload}),
        hideAppLoader: (state, action) => ({isVisible: false})
    }
});

export const { setAppLoader, hideAppLoader } = appLoaderSlice.actions;

export default appLoaderSlice.reducer;
